import { useState, useEffect, useCallback } from 'react';
import {
  ArrowLeft, Save, Eye, Globe, Upload, Plus, Trash2,
  GripVertical, Image, Video, Music, Calendar, Mail,
  User, Layout, Palette, Settings, ExternalLink, Newspaper, Copy, Quote, Star,
  Briefcase, Users, HelpCircle, MessageSquare, Phone, CheckCircle2, XCircle, AlertTriangle, Link, RefreshCw
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue
} from '@/components/ui/select';
import { toast } from 'sonner';
import { cn } from '@/lib/utils';
import api from '@/lib/api';
import CloudinaryUploader, { GalleryUploader } from '@/components/CloudinaryUploader';

export const HomeModuleEditor = ({ data, onChange, siteSlug }) => (
  <div className="space-y-6">
    <div className="space-y-2">
      <Label>Headline</Label>
      <Input 
        value={data.headline || ''} 
        onChange={(e) => onChange({...data, headline: e.target.value})}
        placeholder="Your main headline"
      />
    </div>
    <div className="space-y-2">
      <Label>Subheadline</Label>
      <Textarea 
        value={data.subheadline || ''} 
        onChange={(e) => onChange({...data, subheadline: e.target.value})}
        placeholder="A brief description"
        rows={3}
      />
    </div>
    <div className="space-y-2">
      <Label>Background Image</Label>
      <CloudinaryUploader
        currentImage={data.background_image}
        currentFocalPoint={data.background_focal_point}
        onUpload={(url, publicId, focalPoint) => onChange({
          ...data, 
          background_image: url,
          background_focal_point: focalPoint
        })}
        onRemove={() => onChange({...data, background_image: '', background_focal_point: null})}
        folder={`sites/${siteSlug}/hero`}
        aspectRatio="aspect-[21/9]"
        placeholder="Drop hero background image here"
      />
    </div>
    <div className="grid grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label>CTA Button Text</Label>
        <Input 
          value={data.cta_text || 'Get in Touch'} 
          onChange={(e) => onChange({...data, cta_text: e.target.value})}
        />
      </div>
      <div className="space-y-2">
        <Label>CTA Link</Label>
        <Input 
          value={data.cta_link || '#contact'} 
          onChange={(e) => onChange({...data, cta_link: e.target.value})}
          placeholder="#contact"
        />
      </div>
    </div>
  </div>
);

